import React, { FC, useState } from 'react';
import FormBlock from 'src/components/FormBlock';
import TableSimple from 'src/components/TableSimple';
import translate from '@translate';
import { TableColumnType, TableRowType } from 'src/types/table';
import { TransportApiCallType } from 'src/types/transportDetail';
import { Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ApiCallDetailDialog from './ApiCallDetailDialog';

const allColumns: TableColumnType[] = [
    { key: 'CALLED_AT', label: 'calledAt', type: 'dateTime', defaultShow: true },
    { key: 'SHIPPER', label: 'shipper', defaultShow: true },
    { key: 'OPERATION', label: 'operation', defaultShow: true },
    { key: 'HTTP_STATUS', label: 'httpStatus', defaultShow: true },
    { key: 'DURATION_MS', label: 'durationMs', defaultShow: true },
    { key: 'ERROR_MESSAGE', label: 'errorMessage', defaultShow: true },
];

export interface ApiCallsBlockPropsType {
    data: TransportApiCallType[] | null;
}

const ApiCallsBlock: FC<ApiCallsBlockPropsType> = (props) => {
    const [selectedCall, setSelectedCall] = useState<TransportApiCallType | null>(null);

    if (!props.data?.length) {
        return (
            <FormBlock>
                <Typography>{translate('transportDetail.apiCalls.empty')}</Typography>
            </FormBlock>
        );
    }

    const openDetail = (row: TableRowType) => {
        const match = props.data?.find((item) => String(item.ID) === String(row.ID));
        if (match) {
            setSelectedCall(match);
        }
    };

    return (
        <FormBlock>
            <TableSimple
                rowIdKey="ID"
                rows={props.data}
                allColumns={allColumns}
                columsLabelPrefix="transportDetail.apiCalls.table"
                initSort={{ column: 'CALLED_AT', direction: 'DESC' }}
                disableFilter
                rowActions={[
                    {
                        icon: <VisibilityIcon />,
                        label: translate('transportDetail.apiCalls.action.showDetail'),
                        onClick: openDetail,
                    },
                ]}
            />
            {selectedCall && (
                <ApiCallDetailDialog data={selectedCall} onClose={() => setSelectedCall(null)} />
            )}
        </FormBlock>
    );
};

export default ApiCallsBlock;
